<template>
  <div>
    <!-- Main Sidebar Container -->
    <aside class="elevation-4">
      <sidebar-menu :menu="menu" width="300px" :hideToggle="true" @item-click="onItemClick" />
    </aside>

    <!--Modal-->
    <div class="modal fade" id="change-password">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Şifre Değiştir</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group">
                <label>Eski Şifreniz</label>
                <input @blur="$v.user.oldpassword.$touch()" v-model="$v.user.oldpassword.$model" type="email"
                  class="form-control" :class="{ 'is-invalid': $v.user.oldpassword.$error }"
                  placeholder="Eski şifrenizi giriniz" />
                <small v-if="
                  !$v.user.oldpassword.required && $v.user.oldpassword.$error
                " class="form-text text-danger">Bu alan zorunludur...</small>
              </div>
              <div class="form-group" v-if="!user.id">
                <label>Yeni Şifre</label>
                <input v-model="$v.user.password.$model" type="password" class="form-control"
                  placeholder="Yeni şifrenizi giriniz" />

                <small v-if="!$v.user.password.required && $v.user.password.$error" class="form-text text-danger">Bu
                  alan zorunludur...</small>
                <small v-if="!$v.user.password.minLength && $v.user.password.$error"
                  class="form-text text-danger">Lütfen
                  şifreniz en az
                  {{ $v.user.password.$params.minLength.min }} karakterden
                  oluşmalıdır...
                </small>
                <small v-if="!$v.user.password.maxLength && $v.user.password.$error"
                  class="form-text text-danger">Lütfen
                  şifreniz en fazla
                  {{ $v.user.password.$params.maxLength.max }} karakterden
                  oluşmalıdır...
                </small>
              </div>
              <div class="form-group" v-if="!user.id">
                <label>Yeni Şifre Tekrar</label>
                <input v-model="$v.user.repassword.$model" type="password" class="form-control"
                  placeholder="Yeni şifrenizi tekrar giriniz" />
                <small v-if="
                  !$v.user.repassword.required && $v.user.repassword.$error
                " class="form-text text-danger">Bu alan zorunludur...
                </small>

                <small v-if="
                  !$v.user.repassword.minLength && $v.user.repassword.$error
                " class="form-text text-danger">Lütfen şifreniz en az
                  {{ $v.user.repassword.$params.minLength.min }} karakterden
                  oluşmalıdır...
                </small>
                <small v-if="
                  !$v.user.repassword.maxLength && $v.user.repassword.$error
                " class="form-text text-danger">Lütfen şifreniz en fazla
                  {{ $v.user.repassword.$params.maxLength.max }} karakterden
                  oluşmalıdır...
                </small>
                <small v-if="!$v.user.repassword.sameAs && $v.user.repassword.$error"
                  class="form-text text-danger">Girdiğiniz şifreler birbirleriyle uyuşmuyor...
                </small>
              </div>
            </form>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              İptal
            </button>
            <button type="button" class="btn btn-primary" @click="save()" :disabled="$v.user.$invalid">
              Kaydet
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<style scoped></style>
<script>
import {
  required,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";

export default {
  data() {
    return {
      collapsed: true,
      user: {
        oldpassword: "",
        password: "",
        repassword: "",
      },
      auth: this.$store.getters.getModules,

      menu: this.getMenu(),
    };
  },
  validations: {
    user: {
      oldpassword: {
        required,
      },

      password: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(20),
      },
      repassword: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(20),
        sameAs: sameAs("password"),
      },
    },
  },
  methods: {
    authMenu(value) {
      let menu = this.$store.getters.getModules;

      if (menu[value] == null) return true;

      return !menu[value].isRead;
    },

    getMenu() {
      return [
        {
          class: "text-center ",
          title: "Central Control System",
        },
        {
          title: this.$store.getters.getNameSurname,
          icon: "fa fa-user",
          child: [
            {
              title: "Şifre Değiştir",
              icon: "fa fa-circle",
            },
            {
              title: "Çıkış Yap",
              icon: "fa fa-circle",
            },
          ],
        },
        {
          title: "İşlemler",
          header: true,
        },
        {
          href: "/",
          title: "Anasayfa",
          icon: "fa fa-home",
        },
        {
          href: "/blacklist",
          title: "Müşteri Limitleri",
          icon: "fas fa-times",
          hidden: this.authMenu("Blacklist"),
        },
        {
          href: "/watch",
          title: "Uygulamalar",
          icon: "fas fa-tablet",
          hidden: this.authMenu("AppWatch"),
        },
        /*  {
            href: "/bonus-list",
            title: "Bonuslar",
            icon: "fas fa-gift",
            hidden: this.authMenu("bonusAyarlari"),
          },*/
        {
          href: "/bonus-requests",
          title: "Müşteri Talepleri",
          icon: "fas fa-circle",
          hidden: this.authMenu("BonusReport"),
        },
        {
          href: "/manual-bonus-report",
          title: "Manuel Ekleme Raporları",
          icon: "fas fa-box",
          hidden: this.authMenu("ManuelBonusReport"),

        },
        {
          href: "/panelfront-tracking-report",
          title: "Panel Front Sipariş Takip",
          icon: "fas fa-box",
          hidden: this.authMenu("PanelFrontOrderTrackingReport"),
        },
        {
          href: "/raffle_page",
          title: "Çekiliş Sayfası",
          icon: "fas fa-tablet",
          hidden: this.authMenu("RafflePage"),

        },
        {
          title: "Tanımlamalar",
          header: true,
          hidden: this.authMenu("Definition"),
        },
        {
          title: "Ayarlar",
          icon: "fas fa-cogs",
          hidden: this.authMenu("Setting"),
          child: [
            {
              href: "/users",
              title: "Kullanıcı Ayarları",
              icon: "fas fa-circle",
              hidden: this.authMenu("UserSetting"),
            },
            {
              href: "/departments",
              title: "Departman Ayarları",
              icon: "fas fa-circle",
              hidden: this.authMenu("DepartmentSetting"),
            },
            {
              href: "/apps",
              title: "Uygulama Ayarları",
              icon: "fas fa-circle",
              hidden: this.authMenu("AppSetting"),
            },
            {
              href: "/IpWhitelist",
              title: "IP Whitelist",
              icon: "fas fa-location-arrow"
            },
            {
              title: 'Müşteri Bilgisi',
              icon: 'fas fa-user',
              href: '/pages/profile',
            },
          ],
        },
        {
          title: "Kullanıcı Logları",
          icon: "fas fa-cogs",
          hidden: this.authMenu("Setting"),
          child: [
            {
              href: "/user-logs-list",
              title: "Hatalı Girişler",
              icon: "fas fa-circle",
              hidden: this.authMenu("UserLogList"),
            },
            {
              href: "/Change-password-List",
              title: "Şifre değiştirme listesi",
              icon: "fas fa-circle",
              hidden: this.authMenu("ChangepasswordList"),
            },
            {
              href: "/Normal-User-List",
              title: "Şifre Değiştirt",
              icon: "fas fa-circle",
              hidden: this.authMenu("NormalUserList"),
            }
          ],
        },
      ];
    },

    onToggleCollapse(collapsed) {
      console.log(collapsed);
    },
    onItemClick(event, item) {
      if (item.title == "Şifre Değiştir") this.changePassword();
      else if (item.title == "Çıkış Yap") this.logout();
      sessionStorage.setItem('currentActiveURL', item.href)
    },
    changePassword() {
      $("#change-password").modal();
    },
    logout() {
      this.$store.dispatch("logout");
    },
    save() {
      this.$http
        .post("User/ChangePassword", {
          id: this.$store.getters.getId,
          oldPass: this.user.oldpassword,
          newPass: this.user.password,
        })
        .then(
          (response) => {
            toastr.success("Şifreniz başarıyla değiştirildi.");
            $("#change-password").modal("hide");
          },
          (err) => {
            toastr.error(err.data.Message);
          }
        );
    },
  },
  watch: {
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
      this.menu = this.getMenu();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Menu.vue